import React from "react";
import CreditBalanceReloadLogTableComponent from "./creditBalanceReloadLogTable.component";
import { useSelector } from "react-redux";

function CreditBalanceReloadLogTableContainer({
  rows,
  isFetching,
  isError,
  handleReload,
  handleChangePage,
  handleChangeRowsPerPage,
  totalFiltered,
  paginationOptions,
  tableFilter,
  lang,
  disbursementInfo,
}) {
  const language = useSelector((state) => state.profile.language);

  return (
    <CreditBalanceReloadLogTableComponent
      rows={rows}
      isFetching={isFetching}
      isError={isError}
      handleReload={handleReload}
      handleChangePage={handleChangePage}
      handleChangeRowPerPage={handleChangeRowsPerPage}
      totalFiltered={totalFiltered}
      paginationOptions={paginationOptions}
      tableFilter={tableFilter}
      lang={lang}
      language={language}
      disbursementInfo={disbursementInfo}
    />
  );
}

export default CreditBalanceReloadLogTableContainer;
